import React, { FC, HTMLProps } from "react";
import cn from "classnames";
import { Tag } from "../../components";
import stl from "./index.module.scss";
import CheckIco from "../../assets/iconsComponents/Check";
import { Location } from "../../store/models";

interface Props extends Omit<HTMLProps<HTMLDivElement>, "data" | "onSelect"> {
  data: Location;
  onSelect?: (v: Location) => void;

  selected: boolean;
}

const LocationCard: FC<Props> = ({
  data,
  selected,
  className,
  onSelect,
  ...props
}) => {
  const { name, address, tags } = data;

  return (
    <div
      {...props}
      className={cn(className, stl.block, { [stl.selected]: selected })}
      tabIndex={0}
      onClick={() => onSelect?.(data)}
      onKeyDown={({ key }) => {
        if (key === "Enter" || key === " ") {
          onSelect?.(data);
        }
      }}
    >
      <CheckIco className={stl.check} />
      <h3 className={stl.name}>{name}</h3>
      <i>{address}</i>
      {tags.map((tag) => (
        <Tag key={tag} variant={"primary"}>
          {tag}
        </Tag>
      ))}
    </div>
  );
};

export default LocationCard;
